export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-3c-3b031b897c15b07e1707ede80c85becb.webp";